import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Input, Label, FormGroup } from "reactstrap";
import BizinBackend from "../../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import { useContext } from "react";
import { DF_OT0056Context } from "../context";
import TranspaleStringToComponente from "../../../../components/Dynamic/TranspaleStringToComponente";
import { Checkbox } from "primereact/checkbox";
import NotificationModal from "../../../../components/Common/NotificationModal";

const inputClassName = "rounded font-size-14 border-color-cinza2";

function GridBody() {
  const { userProfile, access_token } = useSelector((state) => ({
    userProfile: state.login.profile,
    access_token: state.login.user.access_token,
  }));

  const csrfToken = useGetCsrfToken();
  const [deliveryTypes, setDeliveryTypes] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [screenMode, setScreenMode] = useState("normal");
  const [formData, setFormData] = useState({
    descricao: "",
    quantidadeVolumeDiario: "",
    valorMercadoriaDiario: "",
    pesoBrutoDiario: "",
    quantidadeVeiculosDiario: "",
    quantidadeVolumeEntrega: "",
    valorMercadoriaEntrega: "",
    pesoBrutoEntrega: "",
    diasAntecedenciaAgendamento: "",
    unidadeAgendamento: "",
    dataEncerramento: "",
    limiteAgendamentosParceiro: "",
    tipoEntrega: "",
    permitirMesmoTipoEntrega: false,
  });
  const [preFilter, setPreFilter] = useState([]);

  const { navigate, location } = useContext(DF_OT0056Context);
  const { idEmpresa, idLocalEntrega } = location.state || {};
  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const handleVehicleChange = (idVeiculo) => {
    setSelectedVehicles((prev) =>
      prev.includes(idVeiculo)
        ? prev.filter((id) => id !== idVeiculo)
        : [...prev, idVeiculo],
    );
  };

  const handleCategoryChange = (idCategoria) => {
    setSelectedCategories((prev) =>
      prev.includes(idCategoria)
        ? prev.filter((id) => id !== idCategoria)
        : [...prev, idCategoria],
    );
  };

  const handleSave = () => {
    setScreenMode("confirm");
  };

  const handleConfirm = async () => {
    try {
      const listaVeiculos =
        selectedVehicles.length > 0 ? selectedVehicles.join(",") : null;

      const listaCategorias =
        selectedCategories.length > 0 ? selectedCategories.join(",") : null;

      const formatDateToISO = (date) =>
        date ? date.split("/").reverse().join("-") : null;

      const payload = {
        1: idLocalEntrega,
        2: formData.descricao || null,
        3: formData.quantidadeVolumeDiario
          ? Number(formData.quantidadeVolumeDiario)
          : null,
        4: formData.valorMercadoriaDiario
          ? Number(formData.valorMercadoriaDiario)
          : null,
        5: formData.pesoBrutoDiario ? Number(formData.pesoBrutoDiario) : null,
        6: null,
        7: formData.quantidadeVeiculosDiario
          ? Number(formData.quantidadeVeiculosDiario)
          : null,
        8: formData.quantidadeVolumeEntrega
          ? Number(formData.quantidadeVolumeEntrega)
          : null,
        9: formData.valorMercadoriaEntrega
          ? Number(formData.valorMercadoriaEntrega)
          : null,
        10: formData.pesoBrutoEntrega
          ? Number(formData.pesoBrutoEntrega)
          : null,
        11: formData.diasAntecedenciaAgendamento
          ? Number(formData.diasAntecedenciaAgendamento)
          : null,
        12: formData.unidadeAgendamento
          ? Number(formData.unidadeAgendamento)
          : null,
        13: formData.tipoEntrega ? Number(formData.tipoEntrega) : null,
        14: formData.permitirMesmoTipoEntrega ? "S" : "N",
        15: formatDateToISO(formData.dataEncerramento) || null,
        16: formData.limiteAgendamentosParceiro
          ? Number(formData.limiteAgendamentosParceiro)
          : null,
        17: listaVeiculos,
        18: listaCategorias,
        19: null,
      };

      const response = await BizinBackend.executeProcedure(
        payload,
        "SRM_Agendamento_Insere_Locais_Desembarque",
        csrfToken,
        access_token,
      );

      setScreenMode("success");
    } catch (error) {
      console.error("Erro ao cadastrar Local de Desembarque:", error);
      setScreenMode("error");
    }
  };

  const handleBack = () => {
    navigate("/DF_OT0055");
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        const [deliveryTypesResponse, vehiclesResponse, categoriesResponse] =
          await Promise.all([
            BizinBackend.executeProcedure(
              {
                1: idEmpresa,
              },
              "FRONT_Workspace_Lista_Tipo_Entrega",
              csrfToken,
              access_token,
            ),

            BizinBackend.executeProcedure(
              {
                1: idEmpresa,
              },
              "SRM_Get_Conhecimento_Transporte_Veiculos",
              csrfToken,
              access_token,
            ),

            BizinBackend.executeProcedure(
              {
                1: idEmpresa,
              },
              "CUA_Get_Categorias",
              csrfToken,
              access_token,
            ),
          ]);

        if (Array.isArray(deliveryTypesResponse)) {
          setDeliveryTypes(deliveryTypesResponse);
        }

        if (Array.isArray(vehiclesResponse)) {
          setVehicles(vehiclesResponse);
        }

        if (Array.isArray(categoriesResponse)) {
          setCategories(categoriesResponse);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    if (csrfToken && access_token && idEmpresa) {
      loadData();
    }
  }, [csrfToken, access_token, idEmpresa]);
  return (
    <>
      {screenMode === "normal" && (
        <div className="form-default-primary df-ot0055-page p-0">
          <div className="box-local-desembarque mb-4">
            <Row className="gx-4 mb-0">
              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="descricao">Descrição</Label>
                  <Input
                    type="text"
                    id="descricao"
                    value={formData.descricao}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="quantidadeVolumeDiario">
                    Quantidade Volume Diário (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="quantidadeVolumeDiario"
                    value={formData.quantidadeVolumeDiario}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="valorMercadoriaDiario">
                    Valor da Mercadoria Diário (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="valorMercadoriaDiario"
                    value={formData.valorMercadoriaDiario}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="gx-4 mb-0">
              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="pesoBrutoDiario">
                    Peso Bruto em KG Diário (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="pesoBrutoDiario"
                    value={formData.pesoBrutoDiario}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="quantidadeVeiculosDiario">
                    Quantidade Veículos Diário (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="quantidadeVeiculosDiario"
                    value={formData.quantidadeVeiculosDiario}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="quantidadeVolumeEntrega">
                    Quantidade Volume Por Entrega (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="quantidadeVolumeEntrega"
                    value={formData.quantidadeVolumeEntrega}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="gx-4 mb-0">
              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="valorMercadoriaEntrega">
                    Valor da Mercadoria Por Entrega (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="valorMercadoriaEntrega"
                    value={formData.valorMercadoriaEntrega}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="pesoBrutoEntrega">
                    Peso Bruto em KG Por Entrega (Máx)
                  </Label>
                  <Input
                    type="number"
                    id="pesoBrutoEntrega"
                    value={formData.pesoBrutoEntrega}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="diasAntecedenciaAgendamento">
                    Dias de Antecedência para Agendamento
                  </Label>
                  <Input
                    type="number"
                    id="diasAntecedenciaAgendamento"
                    value={formData.diasAntecedenciaAgendamento}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="gx-4 mb-0">
              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="unidadeAgendamento">
                    Und. para Agendamento em min.
                  </Label>
                  <Input
                    type="number"
                    id="unidadeAgendamento"
                    value={formData.unidadeAgendamento}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-4">
                  <TranspaleStringToComponente
                    elementId={"Data_Encerramento"}
                    elementProps={{
                      value: "",
                      type: "Date",
                      title: "Data de Encerramento",
                      id: "Filtro_Data_Encerramento",
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => {
                      setPreFilter((state) => [{ ...state[0], ...filters }]);

                      if (filters.Filtro_Data_Encerramento) {
                        setFormData((prev) => ({
                          ...prev,
                          dataEncerramento:
                            filters.Filtro_Data_Encerramento.value,
                        }));
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              <Col lg={4}>
                <FormGroup className="mb-4">
                  <Label for="limiteAgendamentosParceiro">
                    Limite de Agendamentos Diários por Parceiro
                  </Label>
                  <Input
                    type="number"
                    id="limiteAgendamentosParceiro"
                    value={formData.limiteAgendamentosParceiro}
                    onChange={handleInputChange}
                    className={inputClassName}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="gx-4 mb-0 align-items-end">
              <Col lg={4}>
                <FormGroup className="mb-0">
                  <TranspaleStringToComponente
                    elementId={"ID_Tipo_Entrega"}
                    elementProps={{
                      value: "",
                      type: "Combobox",
                      title: "Tipo de Entrega",
                      id: "Filtro_ID_Tipo_Entrega",
                      isDisabled: false,
                      procedure: "FRONT_Workspace_Lista_Tipo_Entrega",
                      procedureParams: [idEmpresa],
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => {
                      setPreFilter((state) => [{ ...state[0], ...filters }]);

                      if (filters.Filtro_ID_Tipo_Entrega) {
                        setFormData((prev) => ({
                          ...prev,
                          tipoEntrega: filters.Filtro_ID_Tipo_Entrega.value,
                        }));
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              <Col lg={8}>
                <FormGroup className="mb-4">
                  <Label
                    htmlFor="permitirMesmoTipoEntrega"
                    className="d-flex align-items-center mb-0 font-size-13 text-muted"
                  >
                    <Checkbox
                      inputId="permitirMesmoTipoEntrega"
                      checked={formData.permitirMesmoTipoEntrega}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          permitirMesmoTipoEntrega: e.checked,
                        }))
                      }
                    />

                    <span className="ms-2">
                      Permitir Agendamentos para mesmo tipo de entrega
                    </span>
                  </Label>
                </FormGroup>
              </Col>
            </Row>
          </div>

          <Row className="gx-3 mt-0">
            <Col lg={6}>
              <div className="checkbox-container">
                <h5 className="checkbox-container-title">
                  Selecione os Veículos
                </h5>

                <div className="checkbox-scroll">
                  {vehicles.map((veiculo) => (
                    <FormGroup key={veiculo.ID_Tipo_Veiculo} className="mb-2">
                      <Label
                        htmlFor={`veiculo-${veiculo.ID_Tipo_Veiculo}`}
                        className="d-flex align-items-center mb-0 font-size-12"
                      >
                        <Checkbox
                          inputId={`veiculo-${veiculo.ID_Tipo_Veiculo}`}
                          checked={selectedVehicles.includes(
                            veiculo.ID_Tipo_Veiculo,
                          )}
                          onChange={() =>
                            handleVehicleChange(veiculo.ID_Tipo_Veiculo)
                          }
                        />

                        <span className="ms-2">
                          {veiculo.Descricao_Veiculo}
                        </span>
                      </Label>
                    </FormGroup>
                  ))}
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="checkbox-container">
                <h5 className="checkbox-container-title">
                  Selecione as Categorias
                </h5>

                <div className="checkbox-scroll">
                  {categories.map((categoria) => (
                    <FormGroup key={categoria.ID_Categoria} className="mb-2">
                      <Label
                        htmlFor={`categoria-${categoria.ID_Categoria}`}
                        className="d-flex align-items-center mb-0 font-size-12"
                      >
                        <Checkbox
                          inputId={`categoria-${categoria.ID_Categoria}`}
                          checked={selectedCategories.includes(
                            categoria.ID_Categoria,
                          )}
                          onChange={() =>
                            handleCategoryChange(categoria.ID_Categoria)
                          }
                        />

                        <span className="ms-2">{categoria.Descricao}</span>
                      </Label>
                    </FormGroup>
                  ))}
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col
              lg={12}
              className="d-flex justify-content-between align-items-center"
            >
              <button
                className="btn bg-primary-dark-inverse fw-bold px-4"
                onClick={handleBack}
              >
                Voltar
              </button>

              <button
                className="btn fw-semibold btn-confirmar-co0005"
                onClick={handleSave}
              >
                Gravar
              </button>
            </Col>
          </Row>
        </div>
      )}

      <NotificationModal
        isOpen={screenMode === "confirm"}
        type="warning"
        titleCustom={
          <>
            Deseja cadastrar as informações
            <br />
            do Local de Desembarque?
          </>
        }
        message='Ao clicar em "Confirmar" o Local de Desembarque será cadastrado.'
        confirmButton
        onConfirm={handleConfirm}
        onClose={() => setScreenMode("normal")}
      />

      <NotificationModal
        isOpen={screenMode === "success"}
        type="success"
        message="Local de Desembarque cadastrado com sucesso!"
        onClose={handleBack}
      />

      <NotificationModal
        isOpen={screenMode === "error"}
        type="error"
        titleCustom="Ops!"
        message="Não foi possível cadastrar o Local de Desembarque."
        onClose={() => setScreenMode("normal")}
      />
    </>
  );
}

export default GridBody;
